
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as UserPairsRegisterIconComponent } from "./user-pairs-register-icon.svg";

export const UserPairsRegisterIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <UserPairsRegisterIconComponent {...props} />;
};
